module.exports = __webpack_public_path__ + "img/c3.f76401bb.svg";